import { render } from "./Year.vue?vue&type=template&id=03f12899"
import script from "./Year.vue?vue&type=script&lang=ts"
export * from "./Year.vue?vue&type=script&lang=ts"
script.render = render

export default script